/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Represents linked accounts for a user (e.g., Limbic)
 */
export interface LinkedAccountModel {
  /** Limbic patient ID */
  limbic_patient_id?: string | null;
  /** Medical records number identifying the Nori patient in Curai */
  curai_patient_mrn?: string | null;
  /** Stripe customer ID; set once the user has a billing account */
  stripe_customer_id?: string | null;
}
